import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'
import { createSlug } from '@/utils/url'

class LearnService {
  static async getDocuments(query = '', page = 1, pageSize = 30, filters = {}) {
    const filterParams = Object.entries(filters)
      .filter(([, value]) => !!value)
      .reduce((acc, [key, value]) => {
        return `${acc}&${key}=${value}`
      }, '')

    return ApiHelper.fetch(
      `${API.URL + API.LEARN}/search-documents/${encodeURIComponent(
        query
      )}?page=${page}&page_size=${pageSize}${filterParams}`
    )
  }

  static async conversation(documentIds, botType, conversation) {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/conversation`, {
      method: 'POST',
      body: JSON.stringify({
        documentIds,
        botType,
        conversation
      })
    })
  }

  static async findAnswerForDocument(queryText, documentId) {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/ask-question`, {
      method: 'POST',
      body: JSON.stringify({
        queryText,
        documentId
      })
    })
  }

  static async summarizeDocument(documentId) {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/summarize-document`, {
      method: 'POST',
      body: JSON.stringify({
        documentId
      })
    })
  }

  static async generateNotes(documentId) {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/generate-notes`, {
      method: 'POST',
      body: JSON.stringify({
        documentId
      })
    })
  }

  static async updateDocument(documentGuid, document) {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/update-document/${documentGuid}`, {
      method: 'POST',
      body: JSON.stringify({
        document
      })
    })
  }

  static async getUserItems() {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/user-items`)
  }

  static async getSources() {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/sources`)
  }

  static async getContentTypes() {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/content-types`)
  }

  static async getCollectionLevels() {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/learn-collection/levels`)
  }

  static async getCollectionDomains() {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/learn-collection/domains`)
  }

  static async getCollectionCreators() {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/learn-collection/creators`)
  }

  static getCollections(query = '', page = 1, pageSize = 30, filters = {}) {
    const filterParams = Object.entries(filters)
      .filter(([, value]) => !!value)
      .reduce((acc, [key, value]) => {
        return `${acc}&${key}=${value}`
      }, '')

    return ApiHelper.fetch(
      `${API.URL + API.LEARN}/learn-collection?query=${encodeURIComponent(
        query
      )}&page=${page}&page_size=${pageSize}${filterParams}`
    )
  }

  static getUserCollections() {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/learn-collection/my-collections`)
  }

  static getCollection(collectionId) {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/learn-collection/${collectionId}`)
  }

  static createCollection(learnCollection) {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/learn-collection`, {
      method: 'POST',
      body: JSON.stringify({
        learnCollection: {
          slug: createSlug(learnCollection.name),
          ...learnCollection
        }
      })
    })
  }

  static updateCollection(learnCollection) {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/learn-collection/${learnCollection._id}`, {
      method: 'PUT',
      body: JSON.stringify({
        learnCollection
      })
    })
  }

  static deleteCollection(collectionId) {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/learn-collection/${collectionId}`, {
      method: 'DELETE'
    })
  }

  static async addDocumentToCollections(documentId, collectionIds) {
    return ApiHelper.fetch(`${API.URL + API.LEARN}/learn-collection/add-document-to-collections`, {
      method: 'PUT',
      body: JSON.stringify({
        documentId,
        collectionIds
      })
    })
  }
}

export default LearnService
